// src/components/ui/LoadingSkeleton.jsx
import React from 'react';
import './LoadingSkeleton.css';

export function LoadingSkeleton({ 
  width = '100%', 
  height = '20px', 
  rows = 1, 
  className = '',
  variant = 'text'
}) {
  const skeletons = Array.from({ length: rows }, (_, index) => (
    <div
      key={index}
      className={`loading-skeleton loading-skeleton--${variant} ${className}`}
      style={{
        width: Array.isArray(width) ? width[index] || width[0] : width,
        height
      }}
    />
  ));

  return rows === 1 ? skeletons[0] : <div className="loading-skeleton-group">{skeletons}</div>;
}

export function UsernameCardSkeleton() {
  return (
    <div className="username-card-skeleton">
      <div className="skeleton-header">
        <LoadingSkeleton width="60%" height="24px" />
        <LoadingSkeleton width="40px" height="20px" variant="rounded" />
      </div>
      <LoadingSkeleton width="80%" height="16px" />
      <LoadingSkeleton width="100%" height="14px" />
      <div className="skeleton-footer">
        <LoadingSkeleton width="100px" height="32px" variant="rounded" />
        <LoadingSkeleton width="80px" height="32px" variant="rounded" />
      </div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="dashboard-skeleton">
      <LoadingSkeleton width="200px" height="32px" className="mb-4" />
      
      <div className="dashboard-grid">
        <div className="stats-skeleton">
          <LoadingSkeleton width="120px" height="24px" />
          <div className="stats-grid-skeleton">
            {[1, 2, 3].map(i => (
              <div key={i} className="stat-item-skeleton">
                <LoadingSkeleton width="60px" height="36px" />
                <LoadingSkeleton width="100%" height="16px" />
              </div>
            ))}
          </div>
        </div>
        
        <div className="subscription-skeleton">
          <LoadingSkeleton width="140px" height="24px" />
          <LoadingSkeleton width="80px" height="32px" variant="rounded" />
          <LoadingSkeleton width="100%" height="16px" rows={2} />
          <LoadingSkeleton width="160px" height="40px" variant="rounded" />
        </div>
        
        <div className="recent-usernames-skeleton">
          <LoadingSkeleton width="160px" height="24px" />
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="recent-username-skeleton">
              <LoadingSkeleton width="120px" height="20px" />
              <LoadingSkeleton width="80px" height="18px" />
            </div>
          ))}
        </div>
        
        <div className="quick-actions-skeleton">
          <LoadingSkeleton width="140px" height="24px" />
          <div className="actions-grid-skeleton">
            {[1, 2, 3].map(i => (
              <div key={i} className="action-skeleton">
                <LoadingSkeleton width="40px" height="40px" variant="circle" />
                <LoadingSkeleton width="80px" height="16px" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
